/*
  Hover-to-open header menus.

  Dawn builds its header navigation from <details>/<summary>, which is click-to-open by
  design. The Honey theme opened its submenus on hover, so this restores that behaviour
  without replacing Dawn's disclosure component: it only toggles the `open` attribute, so
  click, keyboard focus and Escape all keep working exactly as Dawn intends.

  Guards:
    - Only runs where a real pointer can hover (`(hover: hover) and (pointer: fine)`), so
      touch devices keep tap-to-open and never get a stuck-open menu.
    - Only runs at desktop widths; the mobile drawer is untouched.
    - A short close delay keeps the menu open while the pointer crosses the gap between
      the summary and the panel below it.
*/
(function () {
  'use strict';

  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 180;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var isDesktop = window.matchMedia('(min-width: 990px)');

  function active() {
    return canHover.matches && isDesktop.matches;
  }

  function bind(details) {
    if (!details || details.dataset.j4Hover === '1') return;
    details.dataset.j4Hover = '1';

    var summary = details.querySelector('summary');
    if (!summary) return;

    var openTimer = null;
    var closeTimer = null;

    function open() {
      if (!details.open) {
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }
    }

    function close() {
      // Never yank the menu away from someone tabbing through it.
      if (details.contains(document.activeElement)) return;
      if (details.open) {
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      }
    }

    details.addEventListener('mouseenter', function () {
      if (!active()) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, OPEN_DELAY);
    });

    details.addEventListener('mouseleave', function () {
      if (!active()) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY);
    });

    // A click on the top-level item should follow its link rather than re-toggling
    // a menu that hover has already opened.
    summary.addEventListener('click', function () {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
    });
  }

  function scan() {
    var nodes = document.querySelectorAll(
      '.header__inline-menu details, header-menu details, .mega-menu, details.mega-menu'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      bind(el.tagName === 'DETAILS' ? el : el.querySelector('details') || el);
    }
  }

  function boot() {
    scan();

    // The header re-renders in the theme editor and on sticky-header changes.
    var header = document.querySelector('.header-wrapper') || document.body;
    if (window.MutationObserver && header) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(scan, 150);
      }).observe(header, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', scan);
})();
